import Vue from 'vue';

export const drugOrdersStore = Vue.observable({ 
  executeAction:null,
  updatedAt: null      
});

